import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ApiEndPoint } from 'src/app/shared/constants/apis.constant'

@Injectable({
	providedIn: 'root',
})
export class PointingSystemService {
	constructor(private http: HttpClient) {}
	getPointingSystemSettings(countryId: number) {
		return this.http.post(ApiEndPoint.getPointingSystemSettingsApi, {
			countryId: countryId,
		})
	}
	updatePointsSettings(body: any) {
		return this.http.post(ApiEndPoint.updatePointsSettings, body)
	}
	pointsHistoryList(body: any) {
		return this.http.post(ApiEndPoint.pointingSystemHistoryApi, body)
	}
	pointsStatistics(body: any) {
		return this.http.post(ApiEndPoint.PointingSystemStatisticsApi, body)
	}
}
